// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHtmlParser from "react-html-parser";
import { Loader, Toastr, Button } from "@revvsales/components";

// Components Imports
import GoogleSheetConfirmationBox from "./GoogleSheetConfirmationPopup";
import NO_SHEETS from "../../assets/Deleted-Sheet.png";

// Services Imports
import {
  fetchGoogleSheet,
  unLinkGoogleSheetAccount,
  fetchGoogleUserInfo,
  authGoogleSheetService,
} from "../../actions/GoogleSheetActions/googleSheetServices";
import {
  deleteDocumentComponentService,
  addDocumentComponentService,
} from "../../actions/DocumentActions/services";

// Internal Imports
import { GlobalUtils, DocumentUtils } from "../../utils";
import { GOOGLE_SHEET_VIEW_CONTROL } from "../../constants";

// Actions Import
import { QuotationActions } from "../../actions";
import {
  removeComponentInDocument,
  addComponentInDocument,
} from "../../actions/DocumentActions";
import { DOCUMENT_MODE } from "../../constants/document";

// Destructuring
const { toggleTabAndToolPanelData, handleGSheetAuth } = QuotationActions;
const { handleApiErrMsg, writeDataToLocalStorage } = GlobalUtils;
const { emptyTable } = DocumentUtils;
const { EMPTY_SHEET_MSG } = GOOGLE_SHEET_VIEW_CONTROL;

class GoogleCatalogList extends Component {
  state = {
    loader: false,
    sheetFilesInGroupWise: {},
    selectedGroup: "Owned by me",
    userName: "",
    showConfirmationPopupForUnlink: false,
  };

  componentDidMount() {
    this._onInit();
    fetchGoogleUserInfo()
      .then(res => {
        this.setState({
          userName: res.UserInfo.name,
        });
      })
      .catch(error => {
        this._redirectToDocumentTab();
        const message = handleApiErrMsg(error);
        Toastr.showToastr({
          type: "failure",
          message,
          timeout: 2000,
        });
      });
  }

  _onInit = () => {
    this.setState({
      loader: true,
    });
    fetchGoogleSheet()
      .then(res => {
        this.setState({
          loader: false,
          sheetFilesInGroupWise: this._groupApply(res.SheetFiles),
        });
      })
      .catch(error => {
        this.setState({
          loader: false,
          sheetFilesInGroupWise: {},
        });
        const message = handleApiErrMsg(error);
        if (
          message === "Error in fetching Google Sheets" ||
          message === "UnAuthenticated with Google"
        ) {
          this._authGoogleSheet(this.props.gSheetSection);
        } else {
          this._redirectToDocumentTab();
        }
        Toastr.showToastr({
          type: "failure",
          message,
          timeout: 2000,
        });
      });
  };

  _authGoogleSheet = section => {
    // this refers ==> when google sheet auth success then move to particular tab
    const clickedTabItem = {
      name: section.label,
      alias: section.label,
      type: section.type,
      id: section.id,
    };
    authGoogleSheetService()
      .then(res => {
        writeDataToLocalStorage("lastDocPath", window.location.pathname);
        writeDataToLocalStorage("clickedTabItem", clickedTabItem);
        window.location.replace(res.AuthCodeURL);
      })
      .catch(error => {
        console.error(
          `authGoogleSheetService => authEmailVerificationService => ${error}`,
        );
      });
  };

  _groupApply = data => {
    const configGroup = {
      "Owned by me": [],
      "Not owned by me": [],
      Starred: [],
    };
    data.forEach(element => {
      if (element.owned_by_me && element.starred) {
        configGroup["Owned by me"].push(element);
        configGroup.Starred.push(element);
      } else if (element.owned_by_me && !element.starred) {
        configGroup["Owned by me"].push(element);
      } else if (!element.owned_by_me && element.starred) {
        configGroup["Not owned by me"].push(element);
        configGroup.Starred.push(element);
      } else if (!element.owned_by_me && !element.starred) {
        configGroup["Not owned by me"].push(element);
      }
    });
    return configGroup;
  };

  // Incase of fetching sheets any error occured
  _redirectToDocumentTab = () => {
    this.props.toggleTabAndToolPanelData({
      tabView: "DOCUMENT",
      dealTableId: this.props.dealTableId,
      isOpen: false,
      panelView: "DOCUMENT",
      page: "DOCUMENT",
      htmlString: "",
    });
  };

  _changeGroup = selectedGroup => {
    this.setState({
      selectedGroup,
    });
  };

  _unlinkAccount = () => {
    this.setState({
      showConfirmationPopupForUnlink: true,
    });
  };

  _onConfirmActionAboutUnlink = checkedStatus => {
    if (
      checkedStatus &&
      this.props.gSheetSection &&
      this.props.gSheetSection.data &&
      this.props.gSheetSection.data.data &&
      this.props.gSheetSection.data.data.length > 0
    ) {
      const newList = [];
      const { layout, id, googleSheetSectionId, gSheetSection } = this.props;
      // Added table component JSON
      const newTable = {
        ...emptyTable(DOCUMENT_MODE.DOCUMENT),
      };
      layout.forEach(section => {
        newList.push(section.id);
      });
      newTable.label = "";
      newTable.removable = true;
      newTable.lock = true;

      // making compatiable data for type = Table component
      const data = {
        attributes: {
          columnCount: gSheetSection.data.data[0].attributes.columnCount,
          rowCount: gSheetSection.data.data.length,
        },
        data: gSheetSection.data.data,
      };
      newTable.data = data;
      const index = newList.findIndex(item => item === googleSheetSectionId);
      newList.splice(index, 0, newTable.id);
      newList.splice(index + 1, 1);
      unLinkGoogleSheetAccount()
        .then(() => {
          deleteDocumentComponentService(this.props.googleSheetSectionId).then(
            () => {
              this.props.removeComponentInDocument(
                this.props.googleSheetSectionId,
              );
            },
          );
          this.props.addComponentInDocument(newList, newTable);
          addDocumentComponentService(id, newList, newTable).then(() => {
            console.debug("Success >>>>>>");
          });
          this.props.handleGSheetAuth();
          this._redirectToDocumentTab();
        })
        .catch(error => {
          this.setState({
            loader: false,
            sheetFilesInGroupWise: {},
          });
          this._redirectToDocumentTab();
          this.props.handleGSheetAuth();
          const message = handleApiErrMsg(error);
          Toastr.showToastr({
            typre: "failure",
            message,
            timeout: 2000,
          });
        });
    } else {
      unLinkGoogleSheetAccount()
        .then(() => {
          deleteDocumentComponentService(this.props.googleSheetSectionId).then(
            () => {
              this.props.removeComponentInDocument(
                this.props.googleSheetSectionId,
              );
            },
          );
          this.props.handleGSheetAuth();
          this._redirectToDocumentTab();
        })
        .catch(error => {
          this.setState({
            loader: false,
            sheetFilesInGroupWise: {},
          });
          this.props.handleGSheetAuth();
          this._redirectToDocumentTab();
          const message = handleApiErrMsg(error);
          Toastr.showToastr({
            type: "failure",
            message,
            timeout: 2000,
          });
        });
    }
  };

  render() {
    const {
      loader,
      sheetFilesInGroupWise,
      selectedGroup,
      userName,
      showConfirmationPopupForUnlink,
    } = this.state;
    if (loader) {
      return <Loader label="Loading your sheets!" />;
    }
    return (
      <Fragment>
        <div
          data-test="selectgooglesheet-header"
          className="selectgooglesheet-header">
          Table Source:{" "}
          <i>
            <FontAwesomeIcon
              icon={["fas", "file-spreadsheet"]}
              className="google-sheet-icon"
            />
          </i>
          Google sheets
        </div>
        {showConfirmationPopupForUnlink && (
          <GoogleSheetConfirmationBox
            show={showConfirmationPopupForUnlink}
            name="doc-delete-section"
            closePopup={() =>
              this.setState({ showConfirmationPopupForUnlink: false })
            }
            header={`You're about to unlink your Google account`}
            subHeader={`Google sheets from your account are currently linked to tables in this document. Once you unlink, you will lose the data.
              Check the box below, if you'd like to keep a copy of your table and unlink.`}
            checkboxLabel="Keep a copy of my table in the document"
            cancelBtnText="Cancel"
            confirmAction={this._onConfirmActionAboutUnlink}
            okBtnText="Unlink"
            confirmationBoxRef={this._onConfirmActionAboutUnlink}
          />
        )}
        <div className="googlesheet-cataglog-profile-container">
          <div className="googlesheet-cataglog-profile">
            <span className="googlesheet-cataglog-label">{userName}</span>
            <span
              className="googlesheet-cataglog-unlink-account"
              onKeyPress={() => null}
              role="button"
              tabIndex="0"
              onClick={() => this._unlinkAccount()}>
              Unlink Account
            </span>
          </div>
          <div className="googlesheet-cataglog-title">
            <span className="googlesheet-cataglog-label">{selectedGroup}</span>
          </div>
        </div>

        <div className="googlesheet-cataglog-sheet-container">
          <div className="googlesheet-cataglog-scrollable">
            <div className="googlesheet-cataglog-group">
              {Object.keys(sheetFilesInGroupWise).map(item => (
                <div>
                  <Button
                    data-test={`googlecataloglist-${item}`}
                    className={`googlesheet-cataglog-group-label ${
                      item === selectedGroup
                        ? "googlesheet-cataglog-group-label-color"
                        : ""
                    } `}
                    onClick={() => this._changeGroup(item)}>
                    {item}
                  </Button>
                </div>
              ))}
            </div>
            <div className="googlesheet-cataglog-list-wrapper">
              {sheetFilesInGroupWise[selectedGroup] &&
              sheetFilesInGroupWise[selectedGroup].length ? (
                sheetFilesInGroupWise[selectedGroup].map(sheet => (
                  <div
                    className="googlesheet-cataglog-name-link"
                    role="button"
                    tabIndex={sheet.name}
                    onKeyPress={() => this.props.sheetSelection(sheet)}
                    onClick={() => this.props.sheetSelection(sheet)}>
                    <span>
                      <img src={sheet.icon_link} alt="Link" />
                    </span>
                    <span className="googlesheet-name-padding">
                      {sheet.name}
                    </span>
                  </div>
                ))
              ) : (
                <div>
                  <img
                    src={NO_SHEETS}
                    data-test="google-sheet-noitems-img"
                    className="google-sheet-noitems-img"
                    alt="no sheets"
                  />
                  <div className="google-sheet-noitems-msg">
                    <span>
                      {ReactHtmlParser(EMPTY_SHEET_MSG[selectedGroup])}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { googleSheetId, dealTableId } = state.QuotationStore;
  const { gSheetRevvTables } = state.GoogleSheetStore;
  const currentGSheet = gSheetRevvTables[googleSheetId];
  const { components, document: { id } = {} } = state.DocumentStore;
  const gSheetSection = components[googleSheetId]
    ? components[googleSheetId].content
    : null;
  return {
    id,
    googleSheetSectionId: googleSheetId,
    currentGSheet,
    gSheetSection,
    dealTableId,
    components,
  };
};

const mapDispatchToProps = {
  toggleTabAndToolPanelData,
  addComponentInDocument,
  removeComponentInDocument,
  handleGSheetAuth,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GoogleCatalogList);



// WEBPACK FOOTER //
// ./src/components/GoogleCatalog/GoogleCatalogList.js